/**
 * "This is awkward" page (AC1). Shown when an advisor authenticates
 * but Approve has no matching producer record for their email.
 * The API declines to create a session and redirects here.
 *
 * No retry button — the page dead-ends gracefully with a support
 * contact link.
 */

import { Card, Container } from 'react-bootstrap';
import { useReplaceCallbackHistory } from './use-replace-callback-history.js';

// TODO: confirm support address with product before merging
const SUPPORT_EMAIL = 'support@wawanesa.ca';

export function NoProducerPage() {
    useReplaceCallbackHistory('/auth/no-producer');

    return (
        <div className="d-flex align-items-center min-vh-100 bg-light py-4">
            <Container style={{ maxWidth: 520 }}>
                <Card className="shadow-sm border-0">
                    <Card.Body className="p-5 text-center">
                        <h2 className="mb-3">We hit a snag</h2>
                        <p className="text-secondary mb-3">
                            Your sign-in worked, but we couldn&rsquo;t match your account
                            to a producer record. That means the system doesn&rsquo;t know
                            where to file your quotes and applications yet.
                        </p>
                        <p className="text-secondary mb-4">
                            Give Ron a ring at{' '}
                            <a href="tel:+12043992933" className="text-decoration-none fw-semibold">
                                (204) 399-2933
                            </a>{' '}
                            &mdash; he&rsquo;s available 24&times;7 and loves doing tech support.
                        </p>
                        <a
                            href={`mailto:${SUPPORT_EMAIL}?subject=BluForce%20—%20No%20producer%20record`}
                            className="btn btn-outline-primary"
                        >
                            Or email the support team
                        </a>
                    </Card.Body>
                </Card>
            </Container>
        </div>
    );
}
